import { Label } from 'react-bootstrap';
import { NavWrapper, NavItemWrapper } from './styles';

interface Props {
    centerId: number,
    activeKey: string
}

const HomeBloodDrawNav = (props: Props) => {

    const hrefPrefix = `/center/${props.centerId}/action-center/home-blood-draw`

    return (
        <div>
            <NavWrapper bsStyle='tabs' activeKey={props.activeKey} style={{ width: 'initial', marginTop: '10px' }}>

                <NavItemWrapper eventKey='ORDER-SERVICE' href={hrefPrefix}>
                    Home Blood Draw
                </NavItemWrapper>

            </NavWrapper>
        </div>
    )
}

export default HomeBloodDrawNav